module.exports = __webpack_public_path__ + "img/ww.7490768e.png";